import Notice from "./Notice";

class Notices {
  constructor(private readonly _list: Notice[] = []) {
  }

  public isEmpty(): boolean {
    return this._list.length === 0;
  }

  get list() {
    return this._list;
  }
}

export default Notices;
